var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle, _circle2, _line11, _line12, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5082ef",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#5082ef",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5082ef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow-t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2f9e8f",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2f9e8f",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2f9e8f",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 62,
    x2: 62,
    y2: 104,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 62,
    x2: 120,
    y2: 116,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 62,
    x2: 86,
    y2: 132,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 104,
    x2: 120,
    y2: 116,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 104,
    x2: 86,
    y2: 132,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 116,
    x2: 86,
    y2: 132,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 212,
    y1: 112,
    x2: 182,
    y2: 156,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 212,
    y1: 112,
    x2: 242,
    y2: 152,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 212,
    y1: 112,
    x2: 214,
    y2: 190,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 156,
    x2: 242,
    y2: 152,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 182,
    y1: 156,
    x2: 214,
    y2: 190,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 242,
    y1: 152,
    x2: 214,
    y2: 190,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 96,
    r: 48,
    fill: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 150,
    r: 48,
    fill: "url(#glow-t)"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 116,
    x2: 212,
    y2: 112,
    stroke: "#8a8a95",
    strokeWidth: 1.6,
    strokeOpacity: 0.95,
    strokeDasharray: "5 4"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 132,
    x2: 182,
    y2: 156,
    stroke: "#8a8a95",
    strokeWidth: 1.6,
    strokeOpacity: 0.95,
    strokeDasharray: "5 4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 62,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 104,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 116,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 132,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 112,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 156,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 152,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 190,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatform);
export default __webpack_public_path__ + "static/media/cross-platform.bf42eae7e3cf968716c18ab6486bfe7b.svg";
export { ForwardRef as ReactComponent };